import React from 'react';
import './summary.css'; // You can style your component separately

const Summary = () => {
  return (
    <div className="summary-container">
      <table className="summary-table">
        <thead>
          <tr>
            <th>RESUMEN DE OPERACIONES</th>
            <th>PROPIAS</th>
            <th>DE TERCEROS</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Ventas Gravadas a Contribuyentes</td>
            <td>$389.38</td>
            <td>$389.38</td>
          </tr>
          <tr>
            <td>Ventas gravadas a Consumidores</td>
            <td>$389.38</td>
            <td>$389.38</td>
          </tr>
          <tr>
            <td>TOTAL DE OPERACIONES GRAVADAS</td>
            <td>$50.62</td>
            <td>$389.38</td>
          </tr>
          <tr>
            <td>Ventas Exentas a Contribuyentes</td>
            <td>$0.00</td>
          </tr>
          <tr>
            <td>Ventas Exentas a Consumidores</td>
            <td>$440.00</td>
          </tr>
          <tr>
            <td>TOTAL DE OPERACIONES EXENTAS</td>
            <td>$0.00</td>
          </tr>
          <tr>
            <td>Exportaciones Según Facturas Exportación</td>
            <td>$0.00</td>
          </tr>
          <tr>
            <td>Ventas No Sujetas</td>
            <td>$0.00</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Summary;